import React from "react";
import Lottie from "lottie-react";
import { animation } from "models/constants";
import { Box, Stack } from "@mui/material";
import { customColors } from "models/customColors";
import { ReactComponent as Logo } from "images/rs-logo.svg";

export const WakingUpAnimation = () => (
  <Stack justifyContent={"space-between"} alignItems={"stretch"} width={"100%"}>
    <Stack direction={"row"} justifyContent={"flex-end"}>
      <Logo width={83} height={35} style={{ margin: "19px 20px 18px 18px" }} />
    </Stack>
    <Stack
      flex={1}
      justifyContent={"center"}
      alignItems={"center"}
      width={"100%"}
      height={"100%"}
      pb="15%"
    >
      <Lottie animationData={animation} loop={true} />
      <Box
        sx={{
          color: customColors.grayText,
          fontFamily: "Inter, sans-serif",
        }}
      >
        Cloud Web App is waking up...
      </Box>
    </Stack>
  </Stack>
);
